
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-rewriter?{\"id\":\"data-v-159ca27e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ChatMessage.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ChatMessage.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-159ca27e\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ChatMessage.vue"),
  /* scopeId */
  "data-v-159ca27e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ChatMessage.vue
// module id = 112
// module chunks = 1